import React from 'react'
import { Link } from 'react-router-dom'

import s from './Footer.module.scss'
import type { FooterProps } from './Footer.props'
import { ReactComponent as EmailIcon } from './icons/email.svg'
import { ReactComponent as GeoIcon } from './icons/geo.svg'
import { ReactComponent as PhoneIcon } from './icons/phone.svg'
import { ReactComponent as PrivatBankLogo } from './icons/privatbank.svg'
import { ReactComponent as Logo } from './icons/uis-footer-logo.svg'

export function Footer({ ...props }: FooterProps) {
  return (
    <footer className={s.footer}>
      <Logo />

      <a
        href="https://privatbank.ua/"
        className={s.footerBlockColumn}
      >
        <p>за підтримки</p>
        <PrivatBankLogo />
      </a>
      <div className={s.footerBlock}>
        <EmailIcon />
        <a href="mailto:info@uis.org.ua">info@uis.org.ua</a>
      </div>
      <div className={s.footerBlock}>
        <GeoIcon />
        <address>03035, м. Київ, вул. Митрополита Василя Липківського, 36</address>
      </div>
      <div className={s.footerBlock}>
        <PhoneIcon />
        <div className={s.footerBlockColumn}>
          <a href="tel:+380442538558">+380 44 253 85 58</a>
          <a href="tel:+380990799252">+380 99 079 92 52</a>
        </div>
      </div>
    </footer>
  )
}
